<div class="error-dialog-container" (click)="close()">
    <div class="error-dialog-left">
        <mat-icon>warning</mat-icon>
    </div>
    <div class="error-dialog-right">
        <mat-dialog-content>
            Sorry, unable to {{data.action}}<strong>&nbsp;{{data.text}}</strong>.
            <div class="error-detail-text">{{data.detailText}}</div>
            <br/>Please try again later.
        </mat-dialog-content>
    </div>
  </div>
  